import { combineReducers } from "redux";

import ProductsReducer from "./products/reducer";
import LayoutsReducer from "./layouts/reducer";
import CategoryReducer from "./category/reducer";
import LoginReducer from "./auth/login/reducer";
import ChangePasswordReducer from "./auth/change-password/reducer";
import BusinessReducer from "./business/reducer";
import OrderReducer from "./orders/reducer";
import AddressReducer from "./address/reducer";
import UserReducer from "./user/reducer";
import MediaReducer from "./media-center/reducer";
import BrandReducer from "./brands/reducer"
import EcommereceOrderReducer from "./eCommerceOrder/reducer"
import ReviewReducer from "./review/reducer"
import vouchersReducer from "./voucher/reducer"
import chatReducer from "./chat/reducer"
import termsAndConditionReducer from "./termAndCanditions/reducer";
import PrivacyPolicyReducer from "./privacyPolicay/reducer";
import campaignReducer from "./Marketing-Campaign/reducer";
import overViewStatment from "./OrderStatements/reducer";
import SellerPerformanceReducer from "./SellerPerformance/reducer";



const rootReducer = combineReducers({
    Product: ProductsReducer,
    Layout: LayoutsReducer,
    Category: CategoryReducer,
    Login:LoginReducer,
    changepwd:ChangePasswordReducer,
    Business: BusinessReducer,
    Orders: OrderReducer,
    Address: AddressReducer,
    User:UserReducer,
    MediaCenter: MediaReducer,
    Brands: BrandReducer,
    EcommereceOrders: EcommereceOrderReducer,
    Review: ReviewReducer,
    vouchers: vouchersReducer,
    Chat: chatReducer,
    Campaign: campaignReducer,
    TermsAndConditionsSlice: termsAndConditionReducer,
    PolicySlice :  PrivacyPolicyReducer,
    OverViewStatement :  overViewStatment,
    SellerPerformance :  SellerPerformanceReducer,

});

export default rootReducer;